import {React} from 'react';
import { Helmet } from 'react-helmet-async';
import '../App.css'; 
import { Container, Row, Col} from 'react-bootstrap';
import VideoQuienes from './VideoQuienes';

const NuestraEmpresa = () => {

  return (
    <>
    <Helmet>
      <title>Armat03 | Empresa de Seguridad Privada en Buenos Aires</title>
      <meta name="description" content="onocé Armat03, empresa de seguridad privada habilitada en Buenos Aires. Experiencia, supervisión y soluciones adaptadas a cada cliente" />
    </Helmet>
    <div className="header-section-quienes">
    </div>
    <Container fluid className="company-info-section py-5 px-3">
      <Row className='px-5'>
        <Col md={12}>
          <h2>¿QUIENES SOMOS?</h2>
          <p className="text-justify-custom description">
            Somos una empresa de seguridad privada habilitada, especializada en vigilancia y protección de personas y bienes. Brindamos servicios de seguridad integral con guardias capacitados, planificación estratégica y respuesta inmediata, adaptándonos a las necesidades de cada cliente. 
          </p>
        </Col>
      </Row>
      <Row className='mt-5 px-5'>
        <Col md={12}>
          <h2>NOSOTROS</h2>
          <p className="text-justify-custom description">
            En Armat03 creemos en la seguridad basada en confianza y valores sólidos. Nuestra historia comienza cuando el técnico en seguridad Miguel Torres decide poner su experiencia y conocimiento al servicio de una visión propia en el mundo de la seguridad privada. Con un extenso recorrido en el sector y un compromiso inquebrantable con la integridad, Torres funda Armat03 para construir una empresa que refleje su enfoque en la ética y la excelencia. Guiados por esta visión, trabajamos cada día para ofrecer las mejores soluciones, buscando relaciones duraderas y de confianza con cada cliente. En Armat03 cada proyecto representa nuestro compromiso con un servicio profesional y una promesa de calidad. Es por ello que somos más que una empresa de seguridad: somos un equipo comprometido en ofrecer seguridad de calidad. 
          </p>
        </Col>
      </Row>
      <div className='text-center mt-5 '>
        <VideoQuienes className=""/>
      </div>    
    </Container>
    

  </>
  )
};

export default NuestraEmpresa;

